function getFileExtension(filename: string) {
  const extension = filename.split(".").pop();
  return extension ? extension.toLowerCase() : "";
}

export function isImageFile(filename: string) {
  const ext = getFileExtension(filename);
  return ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(ext);
}

export function isPDFFile(filename: string) {
  const ext = getFileExtension(filename);
  return ext === "pdf";
}
type FileType = "pdf" | "image" | "unknown";
export const getFileTypeFromFilename = (filename: string): FileType => {
  if (isPDFFile(filename)) {
    return "pdf";
  } else if (isImageFile(filename)) {
    return "image";
  } else {
    return "unknown";
  }
};

export function downloadFile(link: string, filename?: string) {
  const a = document.createElement("a");
  a.href = link;
  a.download = filename || link.split("/").pop() || "download";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function bytesToSize(bytes: number, precision = 2) {
  const kilobyte = 1024;
  const megabyte = kilobyte * 1024;
  const gigabyte = megabyte * 1024;
  const terabyte = gigabyte * 1024;

  if (bytes >= 0 && bytes < kilobyte) {
    return bytes + " B";
  } else if (bytes >= kilobyte && bytes < megabyte) {
    return (bytes / kilobyte).toFixed(precision) + " KB";
  } else if (bytes >= megabyte && bytes < gigabyte) {
    return (bytes / megabyte).toFixed(precision) + " MB";
  } else if (bytes >= gigabyte && bytes < terabyte) {
    return (bytes / gigabyte).toFixed(precision) + " GB";
  } else if (bytes >= terabyte) {
    return (bytes / terabyte).toFixed(precision) + " TB";
  } else {
    return bytes + " B";
  }
}
